import { Component } from 'preact';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

// Actions
import { nextStepAction } from '../../actions/Section';

// Constants
import { stepTypes } from '../../constants/Steps';

// Utils
import { getStepsForRender } from '../../utilities/section/sectionUtils';
import { removeFromObject } from '../../utilities/common';
import { actionHandler } from '../../utilities/form/formUtils';

class Steps extends Component {
  componentDidMount() {
    // TODO: Fix React Flow Bug if going back and then forward quickly ( between 1-3 seconds)
    // TODO: after error then the next page won't run the actionHandler.
    const {
      pageData,
      currentProgress,
      currentValues,
      userData,
      dispatch,
      setValues,
      setFieldValue,
    } = this.props;
    const steps = getStepsForRender(pageData, currentProgress);
    const data = {
      ...userData,
      ...currentValues,
      setFieldValue,
    };
    if (steps.length) {
      steps.forEach(step => {
        const { component: { onLoad } } = step;
        if (onLoad) {
          actionHandler(onLoad, null, null, dispatch, data, setValues);
        }
      });
    }
  }

  render() {
    const {
      actions,
      currentProgress,
      dispatch,
      errors,
      handleSubmit,
      isValid,
      onBlur,
      onChange,
      pageData,
      setFormValues,
      setValues,
      touched,
      values,
      userData,
      price,
      initialValues,
      setFieldValue,
      activeSectionData,
    } = this.props;
    const activeStepsData = getStepsForRender(pageData, currentProgress);
    if (activeStepsData.length === 0) {
      return <div/>;
    }

    return (
      <div className="steps">
        {activeStepsData.map(activeStep => {
          // Params for all the items
          let stepParams = {
            errors,
            handleSubmit,
            isValid,
            nextStep: actions.nextStepAction,
            onBlur,
            onChange,
            setFormValues,
            setValues,
            touched,
            values,
            userData,
            price,
            dispatch,
            initialValues,
            setFieldValue,
            activeSectionData,
            currentProgress,
          };

          const { component } = activeStep;
          // Params for the individual item
          const removeItems = ['componentName', 'props'];
          stepParams = {
            ...stepParams,
            ...removeFromObject(component, removeItems),
            ...component.actions ? { 'formActions': component.actions } : {},
            ...component.props ? { 'componentProps': component.props } : {},
            ...component.tracking ? { 'tracking': component.tracking } : {},
            ...component.actionProps ? { 'actionProps': component.actionProps } : {},
            submitText: component.submitText || 'Næste',
            ...currentProgress
          };

          const StepComponent = stepTypes[component.componentName];
          return (
            <StepComponent {...stepParams} />
          );
        })}
      </div>
    );
  }
}

export default compose(
  connect(
    dispatch => ({
      actions: bindActionCreators({
        nextStepAction,
      }, dispatch),
      dispatch,
    })
  )
)(Steps);

Steps.defaultProps = {
  currentValues: null,
};

Steps.propTypes = {
  handleSubmit: PropTypes.func,
  currentProgress: PropTypes.object.isRequired,
  pageData: PropTypes.object.isRequired,
  userData: PropTypes.object,
  currentValues: PropTypes.object,
  actions: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  setFormValues: PropTypes.func,
  isValid: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object,
  setValues: PropTypes.func,
  values: PropTypes.object,
  price: PropTypes.string,
  initialValues: PropTypes.object,
  setFieldValue: PropTypes.func,
  activeSectionData: PropTypes.object,
};
